import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { VALIDATION_MESSAGE } from '../../consts/validationMessage';
import { APPCONFIG } from '../../app.config';
import HeaderBasic from '../../components/layout/HeaderBasic';
import { onRequestError, standardRequest } from '../../utils/requests';
import { useFormErrors, useManagedContext } from '../../components/hooks';
import { FormError } from '../../components/common';

// El correo lo manda comunicacion por el proveedor del nodo (Doppler, emBlue o
// SMTP) y el enlace lleva a /change-password, que escribe la nueva en Keycloak
// y en acceso. Con el login por Keycloak, su "¿Olvidó su contraseña?" trae acá.
export const requestPasswordRecovery = (username) =>
    standardRequest('GET', `${APPCONFIG.SITE.WEBAPI}api/usuario/recovery-token/${encodeURIComponent(username)}`)
    .then(() => {
        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Revise su correo para recuperar la contraseña')
        return true
    })
    .catch(e => {
        onRequestError(e)
        return false
    })

function RecoverPasswordView() {

    const { setIsLoading } = useManagedContext()
    const [ formValues, formHandle ] = useForm({ username: '' })
    const [ sent, setSent ] = useState(false)

    const { errorOf, validate } = useFormErrors(() =>
        formValues.username.length === 0 ? { username: VALIDATION_MESSAGE.REQUIRED } : {})

    const onSend = () => {
        if (!validate()) return

        setIsLoading(true)
        requestPasswordRecovery(formValues.username)
        .then(setSent)
        .finally(() => setIsLoading(false))
    }

    return (
        <div>
            <HeaderBasic showMenu={false} />
            <div className='bg-img'>
                <div className="login-container">
                    <section className='lg-c'>
                        <div>
                            <label htmlFor="username" className="form-label">Usuario/a</label>
                            <input
                                id="username"
                                name="username"
                                type="text"
                                className={`form-control ${errorOf('username') ? 'is-invalid' : ''}`}
                                value={ formValues.username }
                                onChange={ formHandle }
                                onKeyUp={ e => e.key === 'Enter' && onSend() }
                            />
                            <FormError message={errorOf('username')} />
                        </div>
                        {sent && <p>Si el usuario existe, le enviamos un correo con el enlace para elegir una contraseña nueva.</p>}
                        <Link to="/login" className="login-link">Volver al inicio de sesión</Link>
                        <div className="mb-3 lg-btn">
                            <button className="btn btn-main" onClick={ onSend }>Enviar enlace</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default RecoverPasswordView;
